import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ForgeActionModule = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "forge-action" */ './forge-action')),
    LoadingSkeleton: () => null,
});
